import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { sortBy, isEmpty } from "lodash";
import { DatePicker, Icon, Select, Spin } from "antd";
import moment from "moment";

import DayView from "./DayView";
import WeekView from "./WeekView";
import MonthView from "./MonthView";

import DateFooter from "../components/DateFooter.compontent";
import { addOneMonth, addOneWeek, removeOneMonth, removeOneWeek } from "../utils/date.utils";
import { TextDuration, TextLabelData } from "../components/TextDuration";
import { roles } from "../../../configs/constants";
import { fetchUsers, getCutoffDate } from "../api/api";
import { selectUserRoleId } from "../../../redux/selectors/user";
import { getRolesList } from "../../../redux/actions/userActions";
import {
  getActivityTrips,
  getActivityVisits,
  getDurationActivity,
  getDurationTrips,
  getGlobalActivity,
  getNumberTrips,
  getNumberVisits
} from "./presence.utils";

function PresenceDetail({ isLoading, ...props }) {
  const { token, roleId, rolesList } = props;
  const [userId, setUserId] = useState(props.match && props.match.params && props.match.params.id);

  const getRangeDate = () => {
    if (props.dateFilters) {
      const ranges = props.dateFilters.substring(1).split("&");
      const startDate = ranges[0].split("=")[1];
      const endDate = ranges[1].split("=")[1];

      const start = moment.unix(startDate.substring(0, startDate.length - 3)).format("YYYY-MM-DD");
      const end = moment.unix(endDate.substring(0, endDate.length - 3)).format("YYYY-MM-DD");
      return [start, end];
    } else return [moment(), moment()];
  };
  const [cutoffDate, setCutoffDate] = useState(null);
  const [rangeDate, setRangeDate] = useState([moment(getRangeDate()[0]), moment(getRangeDate()[1])]);

  const initialView =
    props && props.location && props.location.search && props.location.search.indexOf("view=semaine") !== -1
      ? "semaine"
      : "journee";
  const [view, setView] = useState(initialView);
  const [userName, setUserName] = useState("");
  const [userDetailsRole, setUserDetailRole] = useState(null);
  const [daysData, setDaysData] = useState(null);
  const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);
  const [listUsers, setListUsers] = useState([]);

  useEffect(() => {
    const propsFilters = props.dateFilters.substring(1).split("&");

    if (propsFilters.length === 3) {
      setView(propsFilters[2].split("=")[1]);
    }
  }, [props.dateFilters]);

  useEffect(() => {
    if (!cutoffDate) {
      getCutoffDate(token).then(response => {
        if (response) setCutoffDate(response.date);
      });
    }
  }, []);

  const viewSelector = () => {
    if (view === "journee")
      return (
        <DayView
          setUserDetailRole={setUserDetailRole}
          userDetailsRole={userDetailsRole}
          setDaysData={setDaysData}
          userId={userId}
          user={props.user}
          rangeDate={rangeDate}
          setUserName={setUserName}
          userName={userName}
          isLoading={isLoading}
        />
      );
    if (view === "semaine")
      return (
        <WeekView
          cutoffDate={cutoffDate}
          setUserName={setUserName}
          user={props.user}
          userId={userId}
          rangeDate={rangeDate}
          setUserDetailRole={setUserDetailRole}
          userDetailsRole={userDetailsRole}
          isLoading={isLoading}
        />
      );
    if (view === "mois") return <MonthView />;
  };

  const handleClickOutsidePicker = event => {
    const calendarPanel = document.querySelector(".ant-calendar");

    if (calendarPanel && !calendarPanel.contains(event.target)) {
      setIsDatePickerOpen(false);
      document.removeEventListener("mousedown", handleClickOutsidePicker);
    }
  };

  useEffect(() => {
    return document.removeEventListener("mousedown", handleClickOutsidePicker);
  }, []);

  return (
    <div className="w-full">
      <div className="flex items-center mb-5 justify-between">
        <div className="flex items-center mb-5 justify-between">
          <button
            className="mr-2"
            onClick={() => {
              props.history.push("/presence/presence");
            }}
          >
            <svg
              className="w-6 h-6"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M15 19l-7-7 7-7" />
            </svg>
          </button>
          <div className="text-3xl font-bold text-gray-900">
            Détail des présences de {isLoading ? <Spin /> : userName}
          </div>
        </div>
        {/*<div className={"flex"}> // A mettre quand export ok.*!/*!/*/}
        {/*  <div*/}
        {/*    className="bg-blue-800 rounded-full text-white py-3 px-4 mr-2 cursor-pointer"*/}
        {/*    onClick={() => {*/}
        {/*      setModalOpen(!modalOpen);*/}
        {/*      setModal("export");*/}
        {/*    }}*/}
        {/*  >*/}
        {/*    Exporter les presence*/}
        {/*  </div>*/}
        {/*  <div className="bg-blue-800 rounded-full text-white py-3 px-4 mr-4 cursor-pointer">Exporter les trajets</div>*/}
        {/*</div> *!/*/}
      </div>
      <div className={"my-3 flex items-center"}>
        <button
          className="rounded-full h-10 w-10 flex items-center justify-center"
          style={{ outline: "none" }}
          onClick={() => {
            setRangeDate(removeOneMonth(rangeDate));
          }}
        >
          <Icon type="double-left" />
        </button>
        <button
          className="mx-2 rounded-full h-10 w-10 flex items-center justify-center"
          style={{ outline: "none" }}
          onClick={() => {
            setRangeDate(removeOneWeek(rangeDate));
          }}
        >
          <Icon type="left" />
        </button>
        <div
          onClick={() => {
            if (!isDatePickerOpen) {
              setIsDatePickerOpen(true);
              document.addEventListener("mousedown", handleClickOutsidePicker);
            }
          }}
        >
          <DatePicker.RangePicker
            open={isDatePickerOpen}
            onChange={selectedRangeDate => {
              setRangeDate(selectedRangeDate);
              setIsDatePickerOpen(false);
            }}
            defaultValue={rangeDate}
            value={rangeDate}
            format={"DD/MM/YYYY"}
            placeholder={["Début", "Fin"]}
            renderExtraFooter={() => (
              <DateFooter
                setRangeDate={data => {
                  setRangeDate(data);
                  setIsDatePickerOpen(false);
                }}
              />
            )}
          />
        </div>
        <button
          className="mx-5 rounded-full h-10 w-10 flex items-center justify-center mr-4"
          style={{ outline: "none" }}
          onClick={() => {
            setRangeDate(addOneWeek(rangeDate));
          }}
        >
          <Icon type="right" />
        </button>
        <button
          className="rounded-full h-10 w-10 flex items-center justify-center mr-10"
          style={{ outline: "none" }}
          onClick={() => {
            setRangeDate(addOneMonth(rangeDate));
          }}
        >
          <Icon type="double-right" />
        </button>
        <div className="ml-2 mr-10">
          <Select
            showSearch
            placeholder="Personne"
            style={{ width: 200 }}
            onFocus={async () => {
              const filters = {
                match: {
                  role_id: {
                    $gte: roleId,
                    $ne: roles.CLIENT
                  },
                  clients: { $exists: true, $ne: [] },
                  "clients.id": props.currentClient.id,
                  hide_attendances: false
                },
                project: {
                  _id: 1,
                  email: 1
                }
              };
              const response = await fetchUsers(filters, token);
              setListUsers(response);
            }}
            onChange={userSelectedId => {
              setUserId(userSelectedId);
            }}
          >
            {listUsers &&
              !isEmpty(listUsers) &&
              sortBy(listUsers, "email").map(userItem => (
                <Select.Option key={userItem._id} value={userItem._id}>
                  {userItem.email}
                </Select.Option>
              ))}
          </Select>
        </div>
        <div
          className={`${
            view === "journee" ? "bg-orange-500" : "bg-orange-200"
          } rounded-full text-white py-3 px-4 mx-2 cursor-pointer text-center`}
          onClick={() => setView("journee")}
        >
          Vue journée
        </div>
        <div
          className={`${
            view === "journee" ? "bg-orange-200" : "bg-orange-500"
          } rounded-full text-white py-3 px-4 mx-2 cursor-pointer text-center`}
          onClick={() => setView("semaine")}
        >
          Vue semaine
        </div>
        {/* <div // A remettre quand la vue mois sera en place https://app.zeplin.io/project/5d6396ee6754d79b30d7ad81/screen/5f7c6ce49e876d92b5f670ad
          className={"bg-orange-500 rounded-full text-white py-3 px-4 mx-2 cursor-pointer"}
          onClick={() => setView("mois")}
        >
          Vue mois
        </div> */}
        {cutoffDate && <div className="ml-6 font-bold">Date de cutoff : {moment(cutoffDate).format("DD/MM/YYYY")}</div>}
        {view === "journee" && (
          <div className="ml-12 grid grid-flow-col grid-cols-2 grid-rows-3 gap-1 gap-x-6">
            <TextDuration
              label="Activité des visites"
              duration={getDurationActivity(daysData)}
              durationTotal={getActivityVisits(daysData)}
            />
            <TextDuration
              label="Activite des trajets"
              duration={getDurationTrips(daysData)}
              durationTotal={getActivityTrips(daysData)}
            />
            <TextLabelData label={"Activité global"} data={getGlobalActivity(daysData)} />
            <TextLabelData label={"Nombre de visites"} data={getNumberVisits(daysData)} />
            <TextLabelData label={"Nombre de trajets"} data={getNumberTrips(daysData)} />
          </div>
        )}
      </div>
      {userId && viewSelector()}
    </div>
  );
}

const mapStateToProps = state => {
  return {
    token: state.auth.token,
    roleId: selectUserRoleId(state),
    rolesList: (state.user && state.user.rolesList) || [],
    currentClient: state.currentClient,
    isLoading: state.presenceDetailsWeek.get("isLoading")
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getRolesList: dispatch(getRolesList())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PresenceDetail);



// WEBPACK FOOTER //
// src/modules/presence/presence/PresenceDetail.js